import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 100vh;
`;

export const $HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding-left: ${spacing('xl')};
  padding-right: ${spacing('xl')};
  height: ${spacing(16)};
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid
    ${({ theme }) => transparentize(0.75, theme.colors.default)};
  margin-bottom: ${spacing('lg')};
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.06);
`;

export const $MenuContainer = styled.div`
  position: relative;
  align-items: center;
  height: ${spacing(16)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const $SetUpContainer = styled.div`
  padding: 128px 208px 32px 208px;

  @media ${media.maxWidth.md} {
    padding: ${spacing(28)};
  }

  @media ${media.maxWidth.sm} {
    padding: ${spacing('xl')};
  }
`;
